import React, { useState, useEffect } from 'react';
import { API_BASE_URL, getApiHeaders } from '../config/api';
import './SystemMonitor.css';

const SystemMonitor = () => {
  // Tab management
  const [activeTab, setActiveTab] = useState('sistema');

  // Sistema stats
  const [stats, setStats] = useState(null);
  const [costs, setCosts] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState('today');

  // Notifications
  const [notifications, setNotifications] = useState([]);
  const [notifFilter, setNotifFilter] = useState('all');

  useEffect(() => {
    loadData();
    // loadNotifications(); // Endpoint non disponibile
    const interval = setInterval(() => {
      loadData();
    // loadNotifications(); // Endpoint non disponibile
    }, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, [selectedPeriod]);

  const loadData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        loadStats(),
        loadCosts(),
        loadConversations()
      ]);
    } catch (error) {
      console.error('Error loading data:', error);
    }
    setLoading(false);
  };

  const loadStats = async () => {
    try {
      const date = selectedPeriod === 'today' ? getTodayDate() : null;
      const response = await fetch(`${API_BASE_URL}/api/semantic/stats${date ? `?date=${date}` : ''}`, { headers: getApiHeaders() });
      const data = await response.json();
      setStats(data.stats || []);
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const loadCosts = async () => {
    try {
      const startDate = getStartDate();
      const response = await fetch(`${API_BASE_URL}/api/semantic/costs?startDate=${startDate}`, { headers: getApiHeaders() });
      const data = await response.json();
      setCosts(data);
    } catch (error) {
      console.error('Error loading costs:', error);
    }
  };

  const loadConversations = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/semantic/conversations/1?limit=20`, { headers: getApiHeaders() });
      const data = await response.json();
      setConversations(data.conversations || []);
    } catch (error) {
      console.error('Error loading conversations:', error);
    }
  };

  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  /* ENDPOINT NON DISPONIBILE - Notifiche solo fallback
  const loadNotifications = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/notifications`, { headers: getApiHeaders() });
      const data = await response.json();
      if (data.success) {
        setNotifications(data.notifications);
      }
    } catch (error) {
      console.error('Errore caricamento notifiche:', error);
      // Notifiche fallback
      setNotifications([
        {
          id: 1,
          type: 'info',
          title: 'Sistema Semantico Attivo',
          message: 'Il sistema di RAG semantico è ora completamente operativo',
          read: false,
          createdAt: new Date().toISOString()
        },
        {
          id: 2,
          type: 'success',
          title: 'Database Migrato',
          message: 'Migrazione schema semantico completata con successo',
          read: false,
          createdAt: new Date(Date.now() - 30*60*1000).toISOString()
        },
        {
          id: 3,
          type: 'warning',
          title: 'Training in corso',
          message: '15 nuovi esempi aggiunti al training set',
          read: true,
          createdAt: new Date(Date.now() - 60*60*1000).toISOString()
        },
        {
          id: 4,
          type: 'info',
          title: 'Nuovo ricordo',
          message: 'Aggiunto ricordo nella categoria PASSIONI',
          read: true,
          createdAt: new Date(Date.now() - 2*60*60*1000).toISOString()
        }
      ]);
    }
  };
  */

  // Carica notifiche fallback
  const loadNotifications = () => {
    setNotifications([
      {
        id: 1,
        type: 'info',
        title: 'Sistema Semantico Attivo',
        message: 'Il sistema di RAG semantico è ora completamente operativo',
        read: false,
        createdAt: new Date().toISOString()
      },
      {
        id: 2,
        type: 'success',
        title: 'Database Migrato',
        message: 'Migrazione schema semantico completata con successo',
        read: false,
        createdAt: new Date(Date.now() - 30*60*1000).toISOString()
      },
      {
        id: 3,
        type: 'warning',
        title: 'Training in corso',
        message: '15 nuovi esempi aggiunti al training set',
        read: true,
        createdAt: new Date(Date.now() - 60*60*1000).toISOString()
      },
      {
        id: 4,
        type: 'info',
        title: 'Nuovo ricordo',
        message: 'Aggiunto ricordo nella categoria PASSIONI',
        read: true,
        createdAt: new Date(Date.now() - 2*60*60*1000).toISOString()
      }
    ]);
  };

  const markAsRead = (id) => {
    setNotifications(prev =>
      prev.map(n => n.id === id ? {...n, read: true} : n)
    );
  };

  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({...n, read: true})));
  };

  const deleteNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Adesso';
    if (diffMins < 60) return `${diffMins} min fa`;
    if (diffHours < 24) return `${diffHours} ore fa`;
    return `${diffDays} giorni fa`;
  };

  const getStartDate = () => {
    const date = new Date();
    if (selectedPeriod === 'week') {
      date.setDate(date.getDate() - 7);
    } else if (selectedPeriod === 'month') {
      date.setMonth(date.getMonth() - 1);
    }
    return date.toISOString().split('T')[0];
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTotalStats = () => {
    if (!stats || stats.length === 0) return { requests: 0, tokens: 0, cost: 0, avgLatency: 0 };

    return stats.reduce((acc, stat) => ({
      requests: acc.requests + (stat.total_requests || 0),
      tokens: acc.tokens + (stat.total_tokens || 0),
      cost: acc.cost + (stat.total_cost || 0),
      avgLatency: acc.avgLatency + (stat.avg_latency_ms || 0)
    }), { requests: 0, tokens: 0, cost: 0, avgLatency: 0 });
  };

  const totalStats = getTotalStats();
  const filteredNotifications = notifFilter === 'unread'
    ? notifications.filter(n => !n.read)
    : notifications;
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="system-monitor">
      <div className="page-header orange">
        <h1>Monitor</h1>
        <p className="subtitle">Sistema e Notifiche</p>
      </div>

      {/* TABS */}
      <div className="monitor-tabs">
        <button
          className={`monitor-tab ${activeTab === 'sistema' ? 'active' : ''}`}
          onClick={() => setActiveTab('sistema')}
        >
          Sistema
        </button>
        <button
          className={`monitor-tab ${activeTab === 'notifiche' ? 'active' : ''}`}
          onClick={() => setActiveTab('notifiche')}
        >
          Notifiche
          {unreadCount > 0 && <span className="tab-badge">{unreadCount}</span>}
        </button>
      </div>

      {/* TAB SISTEMA */}
      {activeTab === 'sistema' && (
        <>
          <div className="monitor-controls">
            <select
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              className="period-select"
            >
              <option value="today">Today</option>
              <option value="week">Last 7 Days</option>
              <option value="month">Last 30 Days</option>
            </select>
            <button className="btn-refresh" onClick={loadData}>
              Aggiorna
            </button>
          </div>

          {loading ? (
            <div className="loading">Loading metrics...</div>
          ) : (
            <>
          {/* Overview Stats */}
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">💬</div>
              <div className="stat-content">
                <div className="stat-value">{totalStats.requests}</div>
                <div className="stat-label">Total Requests</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">🎯</div>
              <div className="stat-content">
                <div className="stat-value">{totalStats.tokens.toLocaleString()}</div>
                <div className="stat-label">Tokens Used</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-content">
                <div className="stat-value">${totalStats.cost.toFixed(4)}</div>
                <div className="stat-label">Total Cost</div>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">⚡</div>
              <div className="stat-content">
                <div className="stat-value">
                  {stats && stats.length > 0
                    ? Math.round(totalStats.avgLatency / stats.length)
                    : 0}ms
                </div>
                <div className="stat-label">Avg Latency</div>
              </div>
            </div>
          </div>

          {/* Category Breakdown */}
          {stats && stats.length > 0 && (
            <div className="category-breakdown">
              <h2>📊 Category Breakdown</h2>
              <div className="categories-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="category-card">
                    <div className="category-header">
                      <span className="category-name">{stat.category}</span>
                      <span className="category-requests">{stat.total_requests} req</span>
                    </div>
                    <div className="category-stats">
                      <div className="category-stat">
                        <span>Tokens:</span>
                        <strong>{stat.total_tokens.toLocaleString()}</strong>
                      </div>
                      <div className="category-stat">
                        <span>Cost:</span>
                        <strong>${stat.total_cost.toFixed(6)}</strong>
                      </div>
                      <div className="category-stat">
                        <span>Latency:</span>
                        <strong>{Math.round(stat.avg_latency_ms)}ms</strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Cost Timeline */}
          {costs && costs.daily && costs.daily.length > 0 && (
            <div className="cost-timeline">
              <h2>💸 Cost Timeline</h2>
              <div className="timeline-summary">
                <div className="summary-item">
                  <span>Total Cost:</span>
                  <strong>${costs.summary.totalCost}</strong>
                </div>
                <div className="summary-item">
                  <span>Total Requests:</span>
                  <strong>{costs.summary.totalRequests}</strong>
                </div>
                <div className="summary-item">
                  <span>Avg Cost/Request:</span>
                  <strong>${costs.summary.avgCostPerRequest}</strong>
                </div>
              </div>
              <div className="timeline-chart">
                {costs.daily.map((day, index) => (
                  <div key={index} className="timeline-day">
                    <div className="day-date">{day.date}</div>
                    <div className="day-bar" style={{
                      width: `${(day.daily_cost / costs.summary.totalCost) * 100}%`
                    }}></div>
                    <div className="day-value">${day.daily_cost.toFixed(4)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Recent Conversations */}
          <div className="recent-conversations">
            <h2>💭 Recent Conversations</h2>
            <div className="conversations-table">
              <table>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>User Input</th>
                    <th>Category</th>
                    <th>Cost</th>
                    <th>Latency</th>
                  </tr>
                </thead>
                <tbody>
                  {conversations.map((conv) => (
                    <tr key={conv.id}>
                      <td>{formatDate(conv.created_at)}</td>
                      <td className="conv-input-cell">
                        {conv.user_input || 'N/A'}
                      </td>
                      <td>
                        <span className="category-badge">
                          {conv.category || 'N/A'}
                        </span>
                      </td>
                      <td className="cost-cell">
                        ${conv.cost?.toFixed(6) || '0.000000'}
                      </td>
                      <td className="latency-cell">
                        {conv.latency_ms ? `${conv.latency_ms}ms` : 'N/A'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
            </>
          )}
        </>
      )}

      {/* TAB NOTIFICHE */}
      {activeTab === 'notifiche' && (
        <div className="notifications-section">
          <div className="notifications-controls">
            <button
              className="btn btn-primary"
              onClick={markAllAsRead}
              disabled={unreadCount === 0}
            >
              Segna tutte come lette
            </button>

            <div className="filter-tabs">
              <button
                className={`filter-tab ${notifFilter === 'all' ? 'active' : ''}`}
                onClick={() => setNotifFilter('all')}
              >
                Tutte ({notifications.length})
              </button>
              <button
                className={`filter-tab ${notifFilter === 'unread' ? 'active' : ''}`}
                onClick={() => setNotifFilter('unread')}
              >
                Non lette ({unreadCount})
              </button>
            </div>
          </div>

          <div className="notifications-list">
            {filteredNotifications.length === 0 ? (
              <div className="notifications-empty">
                Nessuna notifica
              </div>
            ) : (
              filteredNotifications.map(notif => (
                <div
                  key={notif.id}
                  className={`notification-item ${notif.type} ${notif.read ? 'read' : 'unread'}`}
                >
                  <div className="notification-content">
                    <h3>{notif.title}</h3>
                    <p>{notif.message}</p>
                    <span className="notification-time">
                      {formatTimeAgo(notif.createdAt)}
                    </span>
                  </div>
                  <div className="notification-actions">
                    {!notif.read && (
                      <button
                        className="btn-icon"
                        onClick={() => markAsRead(notif.id)}
                        title="Segna come letta"
                      >
                        ✓
                      </button>
                    )}
                    <button
                      className="btn-icon"
                      onClick={() => deleteNotification(notif.id)}
                      title="Elimina"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemMonitor;
